import { Clickable, Icon, Row } from 'components';
import { theme } from 'lib';
import mime from 'mime';
import { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

const Image = styled.div`
  position: relative;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  background: url(${(props) => props.src});
  background-repeat: no-repeat;
  z-index: 1;
  background-size: cover;
  background-position: center;
`;

const PostBox = ({ item, index, onClick }) => {
  const [thumbnail, setThumbnail] = useState('');
  const isMobile = useSelector((state) => state.appState.isMobile);
  const dispatch = useDispatch();
  const isVideo = mime.getType(item.media && item.media[0]?.uri)?.includes('video');

  useEffect(() => {
    getThumbnail();
  }, []);

  function getThumbnail() {
    const val = item;

    const m = val?.metaData
      ? val.metaData.image || val.metaData.icon || ''
      : val?.youtubeId
        ? `https://img.youtube.com/vi/${val.youtubeId}/0.jpg`
        : val?.media?.length
          ? val.media[0]?.thumbnail || val.item?.oldMedia[0]
          : null;

    setThumbnail(m);
  }

  function handleGetApp() {
    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        showGetApp: true
      }
    });
  }

  if (isMobile) {
    return (
      <Clickable onClick={() => onClick(index)}>
        <Image size={193} src={thumbnail} />
      </Clickable>
    );
  }

  return (
    <Clickable onClick={() => onClick(index)}>
      <Row bg={theme.GREY_10}>
        <Image size={216} src={thumbnail}>
          {isVideo && (
            <Row
              bg="rgba(210, 216, 223, 0.7)"
              wid="32px"
              ht="32px"
              hasRadius="32px"
              pos="absolute"
              right="16px"
              top="16px"
              centerAll
            >
              <Icon type="playOutline" dimensions={14} />
            </Row>
          )}
        </Image>
      </Row>
    </Clickable>
  );
};

export default memo(PostBox);
